'use strict'


var Fun =  require('../module/func');
var countObj=require('commonjs/act.count.down.v2');
var {getCoupon} = require('./coupon_common');
function iosFixedDate(strDatetime){
  return strDatetime ? strDatetime.replace(/-/g,'/') : '';
};

var miaoCouponList = {
    //调用get_miao_goods 接口返回 秒杀列表html
    bindEvent:function(_ele){
        var _that = this;
        // 优惠券领取事件
          $(_ele).on('click','.coupon-wrap--active',getCoupon);
          $('.coupon__btn').click(function (e) {
            e.stopPropagation();
          });
    },
    getCouponListData : function(params,func){
        params.from = 'tool';
        $.ajax({
            type: 'get',
            url: '//event.midea.cn/promote/w/mabapp/get_miao_couponlist',
            data:params,
            dataType:'jsonp',
            jsonp: 'callback',
            success: function(data){
                //if(data.errcode === 0){
                    var miaoShaGoodsHtml =data.miaoShaGoodsHtml;
                    func(miaoShaGoodsHtml);
                //}
            },
            error:function(){

            },
            complete: function(){
                // return miaoShaGoodsHtml;
            }
        });
    },
    eventBind : function(){
        
    },
    init(){
    	window.MIAOV2CURACTIVETIMEVALLIST = [];//当前激活的秒杀时段对象列表,用于清除计时器
        var _self=this;
        var   $willMiaoPoolList=$('.js-miao-couponlist');
        if($willMiaoPoolList.length>0){
            $willMiaoPoolList.each(function(index,item){
            	let _ele = $(this);
                var miaoStyleType=$(this).attr('data-miao-style-type'),
                miaoData=JSON.parse($(this).attr('data-miao-data')),
                isShowNav=$(this).attr('data-is-show-nav'),
                styleColor=$(this).attr('data-miao-style-color'),
                userData = JSON.parse($(this).attr('data-miao-userdata'));//控件数据

                _self.miaoStyleType=miaoStyleType;
                _self.styleColor=styleColor;
                $(this).html('');
                var params={
                    type:miaoStyleType,//秒杀样式 single or Multiple
                    style_color:styleColor,//颜色 粉、红、蓝。。。
                    pc:1
                };
                let endTime = userData.miao_data[0].end_time ? userData.miao_data[0].end_time:"23:59";
                params.date=userData.miao_data[0].date;
                params.datetime=userData.miao_data[0].date+' '+userData.miao_data[0].time+':00';//秒杀开始时间
                // params.endDatetime = userData.miao_data[1]?userData.miao_data[1].date+' '+userData.miao_data[1].time+':00' : userData.miao_data[0].date + ' 23:59:59';//秒杀结束时间
                params.endDatetime=userData.miao_data[0].date+' '+endTime+':00';//秒杀结束时间
                params.batch_ids=userData.miao_data[0].batch_ids;
                params.userdata = userData;
                params.shop_type = window.shop_type;//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝H5 ,区分是小天鹅还是生活电器还是其他
                params.is_ls = window.isLs;
                params.fsid = window.fsid;
                // _self.miaoTimeArr=params.date;
                _self.getCouponListData(params,function(html){
                    html='<div class="floor_bg js_miaosha_content">'+html+'</div>';
                    var $miaoPoolListHtml = $(html);
                    _ele.append($miaoPoolListHtml);
                    var miaoServerTime = Date.parse(new Date());
                    var aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                    _self.clickDateNav(_ele);//切换日期事件注册
                    _self.clickTimeNav(_ele);//切换时间事件注册
                    _self.countDownInit(_ele,aTime);//倒计时
                    _self.bindEvent(_ele);//注册领券事件
                    window.MIAOV2CURACTIVETIMEVALLIST.push({
                        id:_ele.attr('id'),
                        ele:_ele,
                    });
                    if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                        aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                        _ele.countDown.init(aTime,function(t){//启动开始倒计时
                            _self.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                        });
                    }else{
                        aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                        _ele.countDown.init(aTime,function(t){//启动开始倒计时
                            _self.timeCallback(t,_ele);//回调闭包保存变量_ele
                        });
                    }
                    // countDown.init(aTime,miao.timeCallback);
                    
                    if(userData.time_nav_type == 2){ // 如果是时间类型直接切换
                      _self.getNearTime(_ele);
                    }else{
                      _self.getNearDate(_ele); // 跳转到当前日期时间tab
                    }
                })
            });
        }
    },
    clickDateNav(_ele){
        var _self = this;
    	var userData = JSON.parse(_ele.attr('data-miao-userdata')),//控件数据
            miaoIdType=_ele.attr('data-miao-id-type');//id类型;;//控件数据
        _ele.on('click','.js_date_li',function(){
            var That = $(this),
                ThatDatetime = That.attr('data-datetime'),//日期
                ThatBatchIds=That.attr('data-batch-ids'),//优惠券批次id
                miaoStyleType=That.attr('data-style-type');//秒杀样式
            _ele.find('.nav_date_li').removeClass('active');
            $(this).addClass('active');
            var params={
                type:miaoStyleType,//秒杀样式 single or Multiple
                style_color:_self.styleColor,//颜色 粉、红、蓝。。。
                'datetime':ThatDatetime,
                'endDatetime':That.attr('data-enddatetime')?That.attr('data-enddatetime'): ThatDatetime.substr(0,10) + ' 23:59:59',
                'date':ThatDatetime.substr(0,10),
                'batch_ids':ThatBatchIds,
                'shop_type' : shop_type,//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝商城 ,区分是小天鹅还是生活电器还是东芝商城H5
                'is_ls' : window.isLs,
                'pc':1,
                'userdata':userData,
                fsid:fsid,
            };
            _self.getCouponListData(params,function(html){
                var $miaoPoolListHtml = $(html);
                //$miaoPoolListHtml.addClass(params.style_color +" ");
                _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
                var miaoServerTime = Date.parse(new Date());
                //清除旧计时器,换上新的计时器
                var aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
                    if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                        clearInterval(item.ele.countDown.timeInterVal);
                        if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                            aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                            _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                _self.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                            });
                        }else{
                            aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                            _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                _self.timeCallback(t,_ele);//回调闭包保存变量_ele
                            });
                        }
                    }
                });
                var nonStockCount = 0; 
                _ele.find('.js_miao_item').each(function(index,item){
                  if($(item).attr('data-state') == 4){
                    nonStockCount++;
                  }
                });
                if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
                  console.log(That.parents('li.nav_date'));
                  console.log(That.parents('li.nav_date').next());
                  var clickDateO = That.next('.js_date_li').length?That.next('.js_date_li'):(That.parents('li.nav_date').next().length?That.parents('li.nav_date').next().find('.js_date_li'):null);
                  if(clickDateO){
                    console.log(clickDateO);
                    clickDateO.trigger('click');
                  }else{
                    _self.getNearTime(_ele);
                  }
                  
                }else{
                  _self.getNearTime(_ele);
                }
                _self.bindEvent(_ele);//注册领券事件
            });
        });
    },
    clickTimeNav(_ele){
        var _self = this;
    	var userData = JSON.parse(_ele.attr('data-miao-userdata')),//控件数据
                    miaoIdType=_ele.attr('data-miao-id-type');//id类型;;//控件数据;//控件数据
        _ele.on('click','.nav_time',function(){
            var That = $(this),
                ThatDatetime = That.attr('data-datetime'),//日期
                ThatBatchIds=That.attr('data-batch-ids'),//优惠券批次id
                miaoStyleType=That.attr('data-style-type');//秒杀样式
            _ele.find('.nav_date_li').removeClass('active');
            $(this).addClass('active');
            var params={
                type:miaoStyleType,//秒杀样式 single or Multiple
                style_color:_self.styleColor,//颜色 粉、红、蓝。。。
                'datetime':ThatDatetime,
                'date':ThatDatetime.substr(0,10),
                'endDatetime':That.attr('data-enddatetime')?That.attr('data-enddatetime'): ThatDatetime.substr(0,10) + ' 23:59:59',
                'batch_ids':ThatBatchIds,
                'shop_type' : shop_type,//根据isLs配置url,改为shop_type： 1小天鹅 2生活电器 3东芝商城 ,区分是小天鹅还是生活电器还是东芝商城H5
                'is_ls' : window.isLs,
                'pc':1,
                'userdata':userData,
                'fsid':fsid,
            };
            _self.getCouponListData(params,function(html){
                var $miaoPoolListHtml = $(html);
                //$miaoPoolListHtml.addClass(params.style_color +" ");
                _ele.find('.js_miaosha_content').html($miaoPoolListHtml);
                var miaoServerTime = Date.parse(new Date());
                //清除旧计时器,换上新的计时器
                var aTime= {serverTime:miaoServerTime,startTime: params.datetime};
                window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
                    if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                        clearInterval(item.ele.countDown.timeInterVal);
                        if(miaoServerTime > Date.parse(iosFixedDate(params.datetime)) && miaoServerTime < Date.parse(iosFixedDate(params.endDatetime))){//活动已经开始，启动结束倒计时
                            aTime= {serverTime:miaoServerTime,startTime: params.endDatetime,endTime:params.endDatetime};
                            _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                _self.toEndtimeCallback(t,_ele);//回调闭包保存变量_ele
                            });
                        }else{
                            aTime= {serverTime:miaoServerTime,startTime: params.datetime,endTime:params.endDatetime};
                            _ele.countDown.init(aTime,function(t){//启动开始倒计时
                                _self.timeCallback(t,_ele);//回调闭包保存变量_ele
                            });
                        }
                    }
                });
                var nonStockCount = 0; //当前场已售罄商品数
                _ele.find('.js_miao_item').each(function(index,item){
                  console.log($(item).attr('data-state'));
                  if($(item).attr('data-state') == 4){
                    console.log($(item).attr('data-state')+'==? 4');
                    nonStockCount++;
                  }
                });
                if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场

                  var clickTimeO = That.next('.nav_time').length?That.next('.nav_time'):null;
                  if(clickTimeO){
                      console.log(clickTimeO);
                      setTimeout(function(){
                          console.log('setTimeout',clickTimeO);
                          clickTimeO.trigger('click');
                      });
                    
                  }
                }
                _self.bindEvent(_ele);//注册领券事件
            });
        });
    },
    countDownInit: function(_ele, aTime){
        if(_ele.length>0){
            var userData = JSON.parse(_ele.attr('data-miao-userdata'));//控件数据
            var $miao_count=_ele.find('.js_miao_count');
            var miaoServerTime = Date.parse(new Date());
            if($miao_count[0]){
                _ele.countDown = countObj.countDown();
            }
        }
    },
    toEndtimeCallback:function(t, _ele){ // 距离结束倒计时
        if(t.total > 0 ){
            this.timeStart(t, _ele);

        } else { // 已结束
            this.timeEnd(t, _ele);
        }
    },
    timeBeforeLong:function(t,_ele){
        //抢券状态变化 样式 按钮 link
        _ele.find('.mc_modal_over').hide();
        _ele.find('.mc_btn_will_start').show().find('.mc_modal_tips').text('未开始');
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);

    },
    //时间小于30min
    timeBefore:function(t,_ele){
        //抢券状态变化 样式 按钮 link
        _ele.find('.mc_modal_over').hide();
        _ele.find('.mc_btn_will_start').show().find('.mc_modal_tips').text('即将开始')
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);
    },
    timeCallback: function(t, _ele){
        var _self = this;
        if(t.total > 30 *60*1000){ // 距离开始大于30分钟，显示未开始
            _self.timeBeforeLong(t,_ele);

        } else if(t.total > 0){ // 距离开始30分钟以内，显示即将开始
            _self.timeBefore(t,_ele);

        } else if(t.total <= 0){

            var nextEndTime;
            let myMiaoServerTime = new Date(Fun.timestampToTime(parseInt(window.miaoServerTime))).getTime();

            if(_ele.attr('data-miao-time-nav-type') == '1'){ // 日期类型秒杀，优先取endtime,无则使用当天 23:59 作为倒计时终点
                let $dateli = _ele.find('.nav_date_li.active');
                if($dateli.attr('data-endtime')){
                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' ' + $dateli.attr('data-endtime'));
                }else{
                    nextEndTime = iosFixedDate($dateli.attr('data-date') + ' 23:59:59');
                }
                

            } else if (_ele.attr('data-miao-time-nav-type') == '2'){ // 时间类型秒杀 优先取endtime,无则使用当天 23:59 作为倒计时终点
                let $timeli = _ele.find('.nav_time.active');
                if($timeli.attr('data-endtime')){
                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' ' + $timeli.attr('data-endtime'));
                }else{
                    nextEndTime = iosFixedDate($timeli.attr('data-date') + ' 23:59:59');
                }

            } else { // 日期时间类型秒杀，以当前时段的终点作为倒计时终点
                nextEndTime = iosFixedDate(_ele.find('.nav_time.active').find('.time_area_v2').attr('data-enddatetime'));
            }

            // 换成活动结束倒计时器
           _self.startSwitchCountDownInit({serverTime: myMiaoServerTime, startTime: nextEndTime}, _ele);
        }
    },
    // 活动开始切换结束倒计时 
    startSwitchCountDownInit(aTime, _ele){
        var _self = this;
        // 清除旧计时器,换上新的计时器
        window.MIAOV2CURACTIVETIMEVALLIST.forEach((item,index)=>{
            if(item.id == _ele.attr('id') && item.ele && item.ele.countDown){
                clearInterval(item.ele.countDown.timeInterVal);
                item.ele.countDown.init(aTime, function(t){
                    _self.toEndtimeCallback(t, _ele);
                });
            }
        });
    },
    timeStart(t, _ele){
    	_ele.find('.mc_modal_over').hide();
        //倒计时 时间数字变化
        var $count=_ele.find('.js_miao_count');
        $count.find('.mc_time_state_desc').text('距离当前场结束剩余');
        $count.find('.js_count_d').text(t.days);
        $count.find('.js_count_h').text(t.hours);
        $count.find('.js_count_m').text(t.minutes);
        $count.find('.js_count_s').text(t.seconds);
    },
    timeEnd(t,_ele){
        
    	_ele.find('.mc_modal_over').hide();
        _ele.find('.mc_modal_time_over').show()
    },
    getNearTime(_ele){
    	console.log(_ele);
        var curDate = new Date();
        var hour = curDate.getHours() > 9 ? curDate.getHours() :  '0' + curDate.getHours();
        var min = curDate.getMinutes() >9 ? curDate.getMinutes():'0'+curDate.getMinutes();
        var time = hour + ':' + min +':00';
        var year = curDate.getFullYear();
        var mon = curDate.getMonth()+1;
        mon = (mon+'').length>1?mon:'0'+mon;
        var date = curDate.getDate() > 9 ? curDate.getDate() : '0'+curDate.getDate();
        date= year+ '-' + mon + '-' + date;
        var dateTime = date + ' ' + time;
        // var lowV = time, highV = time;
        var clickTimeO;
          var lTime='',hTime='';
        _ele.find('.nav_time').each(function(index,item){
           
            if(new Date(dateTime).getTime() >= new Date($(item).attr('data-datetime')).getTime()){
              lTime = $(item);
            }else{
              if(index == _ele.find('.nav_time').length-1 && !lTime){//所有活动都大于当前时间，则设置第一个活动页面
                lTime = $(_ele.find('.nav_time')[0]);
              }else{
                hTime = $(item);
              }
              
            }

        });
        clickTimeO = lTime;
        // var nonStockCount = 0; //当前场已售罄商品数
        // _ele.find('.js_miao_item').each(function(index,item){
        //   if($(item).attr('data-state') == 4){
        //     nonStockCount++;
        //   }
        // });
        // if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
        //   clickTimeO = lTime.next('.nav_time').length?lTime.next('.nav_time'):lTime;
        // }
        if(clickTimeO){

            clickTimeO.trigger('click');
        }
    },
    getNearDate(_ele){
    	console.log(_ele);
        var curDate = new Date();
        var hour = curDate.getHours() > 9 ? curDate.getHours() :  '0' + curDate.getHours();
        var min = curDate.getMinutes() >9 ? curDate.getMinutes():'0'+curDate.getMinutes();
        var time = hour + ':' +min +':00';
        var year = curDate.getFullYear();
        var mon = curDate.getMonth()+1; 
        mon = (mon+'').length>1?mon:'0'+mon;
        // date = curDate.getDate()
        var date = curDate.getDate() > 9 ? curDate.getDate() : '0'+curDate.getDate();
        date= year+ '-' + mon + '-' + date;
        // var dateTime = date + ' ' + time;
        // var lowV = time, highV = time;
        var clickDateO;
        var lDate = '',hDate = '';
        
        _ele.find('.js_date_li').each(function(index,item){
            console.log('date:',date);
            console.log('data-date:',$(item));
            console.log('data-date:',$(item).attr('data-date'));
            if(new Date(date).getTime() >= new Date($(item).attr('data-date')).getTime()){
              console.log('lDate data-date:',$(item).attr('data-date'));
              lDate = $(item);
            }else{
              if(index == _ele.find('.js_date_li').length-1 && date>$(item).attr('data-date')){
                console.log('lDate else data-date:',$(item).attr('data-date'));
                lDate = $(_ele.find('.js_date_li')[0]);
              }else{
                console.log('hDate else data-date:',$(item).attr('data-date'));
                hDate = $(item);
              }
            }
        });
        clickDateO = lDate;
        // var nonStockCount = 0; 
        // _ele.find('.js_miao_item').each(function(index,item){
        //   if($(item).attr('data-state') == 4){
        //     nonStockCount++;
        //   }
        // });
        // if(nonStockCount == _ele.find('.js_miao_item').length){//如果已经都售罄则直接转向下一场
        //   clickDateO = lDate.next('.js_date_li').length?lDate.next('.js_date_li'):lDate;
        // }
        
        if(clickDateO){
          console.log(clickDateO);
            clickDateO.trigger('click');
        }
    },
}

module.exports = miaoCouponList;


// WEBPACK FOOTER //
// ./module/widget.miao.couponlist.js